import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import React, { Component } from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { toInt } from '../utilities/common';
import { getLocalText } from '../utilities/language';
export var RequestError = /*#__PURE__*/function (_Error) {
  _inherits(RequestError, _Error);
  function RequestError() {
    var _this;
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, RequestError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RequestError).call(this, error));
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), RequestError);
    }
    var errorText;
    switch (error.code) {
      default:
        errorText = null;
        break;
      case 400:
        errorText = error.i18n_prompt ? getLocalText("error.".concat(error.i18n_prompt)) // 后端错误提示
        : getLocalText('RequestError.400');
        break;
      case 404:
        errorText = getLocalText('RequestError.404'); // '资源未找到';
        break;
      case 403:
        errorText = getLocalText('RequestError.403'); // '没有访问权限';
        break;
      case 401:
        errorText = getLocalText('RequestError.401'); // '请求未授权';
        break;
    }
    if (!errorText) {
      if (error.code >= 500) errorText = getLocalText('RequestError.biggerThan400');
      // '服务器错误';
      else if (error.code >= 400) errorText = getLocalText('RequestError.biggerThan500');
      // '客户端错误';
      else errorText = getLocalText('RequestError.unknow'); // '未知错误';
    }

    _this.name = "Request Error: ".concat(errorText, "(code: ").concat(error.code, ") ").concat(error.message);
    return _this;
  }
  return RequestError;
}(_wrapNativeSuper(Error));
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  function ErrorBoundary() {
    var _getPrototypeOf2;
    var _this2;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
      error: null
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "throwError", function (error) {
      _this2.setState({
        error: error
      });
    });
    return _this2;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      // component info
      this.throwError(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$error = this.state.error,
        error = _this$state$error === void 0 ? {} : _this$state$error;
      var _this$props = this.props,
        children = _this$props.children,
        restProps = _objectWithoutProperties(_this$props, ["children"]);
      if (typeof children !== 'function') {
        error = new TypeError('the children of ErrorBoundary Component must be callable');
      }
      if (!error) {
        return children(restProps, this.throwError);
      }
      console.error && console.error(error);
      if (error.code) {
        // http error
        error = new RequestError(error);
      }
      return React.createElement(MainView, null, React.createElement("div", {
        className: errorBoxCls
      }, React.createElement("h2", null, error.name), React.createElement("pre", null, error.stack)));
    }
  }]);
  return ErrorBoundary;
}(Component);
export { ErrorBoundary as default };
export var errorBounder = function errorBounder(WrappedComponent) {
  var ConnectedComponent = function ConnectedComponent(props) {
    return React.createElement(ErrorBoundary, null, function (_, throwError) {
      return React.createElement(WrappedComponent, _extends({}, props, {
        throwError: throwError
      }));
    });
  };
  ConnectedComponent.displayName = "ErrorBounded(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Unknown', ")");
  return ConnectedComponent;
};
var MainView = /*#__PURE__*/styled("div", {
  target: "e18r78op0"
})("position:relative;max-width:900px;margin:auto;padding:", function (_ref) {
  var vgap = _ref.vgap;
  return toInt(vgap, 30);
}, "px ", function (_ref2) {
  var hgap = _ref2.hgap;
  return toInt(hgap, 20);
}, "px;");
var errorBoxCls = /*#__PURE__*/css("background-color:#ffefee;padding:20px;");